export default __webpack_public_path__ + "static/media/logo-light.c8d2a05b.svg";